<template>
  <div class='group-wise'>
    <div class='group'><slot name='group'></slot></div>
    <div class='space1  '></div>

    <div class='rank'><span><img src="../../assets/img/reward/一等奖.png" alt=""></span></div>
    <div class='space2'></div>
    <div class='rewards'><slot name='rewards1'></slot></div>
    <div class='works1'><slot name='works1'></slot></div>
    <div class='works-name1'><slot name='works-name1'></slot></div>
    <div class='space4'></div>

    <div class='rank'><span><img src="../../assets/img/reward/二等奖.png" alt=""></span></div>
    <div class='space2'></div>
    <div class='rewards'><slot name='rewards2'></slot></div>
    <div class='works2'><slot name='works2'>                    </slot></div>
    <div class='space3'></div>
    <div class='works-name2'><slot name='works-name2'></slot></div>
    <div class='space5'></div>
    <div class='space4'></div>

    <div v-if="isThird">
      <div class='rank'><span><img src="../../assets/img/reward/三等奖.png" alt=""></span></div>
      <div class='space2'></div>
      <div class='rewards'><slot name='rewards3'></slot></div>
      <div class='works3'><slot name='works3'></slot></div>

      <div class='works-name3'><slot name='works-name3'></slot></div>
      <div class='space5'></div>
      <div class='space4'></div>
    </div>
    <div class='look-up'><div><slot name='link'></slot></div></div>
    <div class='space6'></div>
  </div>
</template>

<script>
export default {
  name: 'GroupWise',
  props: {
    isThird: {
      type: Boolean,
      default() {
        return true
      }
    },
  }
}
</script>

<style lang='less' scoped>
.group-wise {
  width: 100%;
  color: #94282E;
  .group {
    height: 70px;
  }

  .space1 {
    height: 72px;
  }

  .space2 {
    height: 44px;
  }

  .space3 {
    height: 46px;
  }

  .space3 {
    height: 20px;
  }

  .space4 {
    height: 68px;
  }

  .space5 {
    height: 10px;
  }

  .rewards {
    height: 68px;
  }

  .works1 {
    height: 468px;
  }

  .works2 {
    height: 230px;
  }

  .works3 {
    height: 214px;
  }

  .works-name1 ,.works-name2,.works-name3{
    height: 20px;
  }

  .look-up {
    height: 40px;
  }

  .space6 {
    height: 116px;
  }
  .rank {
    opacity: 1;
    font-size: 26px;
    font-weight: 400;
    text-align: center;
    color: #fefeff;
    letter-spacing: 1px;
    >span {
      width: 230px;
      height: 37px;
    }
  }
  .look-up {
    position: relative;
    >div {
      position: absolute;
      border-radius: 10px;
      width: 304px;
      height: 48px;
      line-height: 50px;
      background-image: url('../../assets/img/reward/odd.png');
      background-size: 100% 100%;
      left: 50%;
      transform: translate(-50%);
    }
  }
}


</style>